import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { values } from "lodash"

import HeaderColumn from "../index.jsx"
import StatelessCheckbox from "@cirrus/legacy/app-components/form-controls/checkboxes/stateless-checkbox/index.jsx"
import { htmlType } from "../../constants/index.es6"

import commonStyles from "@cirrus/legacy/app-components/table-v2/common-styles/styles.less"

const HeaderCheckboxColumn = ({ className, htmlType, onSelect, isSelected, isDisabled }) => {
  return (
    <HeaderColumn
      htmlType={htmlType}
      className={classNames(commonStyles.checkboxColumn, commonStyles.controlledWidth, className)}
      onClick={(e) => {
        e.stopPropagation()
      }}>
      <StatelessCheckbox
        dataQa="table-check-all"
        className={commonStyles.checkbox}
        isChecked={isSelected}
        disabled={isDisabled}
        label=""
        onChange={(checked) => onSelect(checked)}
      />
    </HeaderColumn>
  )
}

HeaderCheckboxColumn.propTypes = {
  className: PropTypes.string,
  htmlType: PropTypes.oneOf(values(htmlType)),
  onSelect: PropTypes.func,
  isSelected: PropTypes.bool,
  isDisabled: PropTypes.bool,
}

export default HeaderCheckboxColumn
